import React from 'react'

interface IProps {
  open: boolean
  onClick: () => void
}

export const ToggleMenuIcon = (props: IProps) => {

  return (
    <button className={`toggle-menu-icon ${props.open && "toggle-menu-icon--open"}`} onClick={props.onClick}>
      <div className="toggle-menu-icon--line1" />
      <div className="toggle-menu-icon--line2" />
    </button>
  )
}